<div class="about-group">
  <div class="about-wrapper">
    <h1>Community Guidelines</h1>
    <h3>INTRODUCTION</h3>
    <p>
      Welcome to www.avaana.com.au, an online marketplace connecting health, fitness, wellbeing, spa, beauty and
      otherpractitioners and businesses with Australians through an interactive online platform. The Platform is owned
      and operated by Avaana Pty Ltd ACN 610 520 600 (Avaana).
    </p>
    <p>
      As the context requires, terms not otherwise defined in these Community Guidelines (Guidelines) will have their
      corresponding meaning in theAvaana Terms of Use and Booking Conditions.
    </p>
    <p>
      These Guidelines aim to establish a few ground rules to keep the Platform safe and useful for everyone. Please
      read the Guidelines contained in this document carefully. By posting Provider Content or User Content onto the
      Platform you acknowledge that you have read and understood and accept these Guidelines. We trust that you can be
      responsible in your use of the Platform but if you can’t or you do not agree with any part of these Guidelines,
      you must not use the Platform.
    </p>
    <h2>GUIDELINES</h2>
    <h3>Prohibited Content</h3>

    <ol>
      <li>
        <p>What personal information do we collect from the people that visit our blog, website or app?</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              When contacting or subscribing on our site, as appropriate, you may be asked to enter your name, email
              address, phone number or other details to help you with your experience.
            </p>
          </li>
          <li>
            <p>
              When making online bookings with your selected practitioner or class provider, you will be required to
              place payment details on our secure system to confirm this transaction.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>When do we collect information?</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              We collect information from you when you subscribe to a newsletter, fill out a form or enter information
              on our site.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>How do we use your information?</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              We may use the information we collect from you when you register, make a purchase, sign up for our
              newsletter, respond to a survey or marketing communication, surf the website, or use certain other site
              features in the following ways:
            </p>
            <ul>
              <li>
                <p>
                  To personalize your experience and to allow us to deliver the type of content and product offerings in
                  which you are most interested.
                </p>
              </li>
              <li>
                <p>To improve our website in order to better serve you.</p>
              </li>
              <li>
                <p>To follow up with them after correspondence (live chat, email or phone inquiries)</p>
              </li>
            </ul>
          </li>
        </ol>
      </li>
      <li>
        <p>How do we protect your information?</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make
              your visit to our site as safe as possible.
            </p>
          </li>
          <li>
            <p>We use regular Malware Scanning.</p>
          </li>
          <li>
            <p>Our site is secured by a trusted SSL certificate.</p>
          </li>
        </ol>
      </li>
      <li>
        <p>Do we use 'cookies'?</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive
              through your Web browser (if you allow) that enables the site's or service provider's systems to recognize
              your browser and capture and remember certain information.
            </p>
          </li>
          <li>
            <p>
              For instance, we use cookies to help us remember and process the items in your shopping cart. They are
              also used to help us understand your preferences based on previous or current site activity, which enables
              us to provide you with improved services.
            </p>
          </li>
          <li>
            <p>
              We also use cookies to help us compile aggregate data about site traffic and site interaction so that we
              can offer better site experiences and tools in the future.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>Cookies</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              We use cookies to compile aggregate data about site traffic and site interactions in order to offer better
              site experiences and tools in the future. We may also use trusted third-party services that track this
              information on our behalf.
            </p>
          </li>
          <li>
            <p>
              You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn
              off all cookies. You do this through your browser settings. Since browser is a little different, look at
              your browser's Help Menu to learn the correct way to modify your cookies.
            </p>
          </li>
          <li>
            <p>
              If you turn cookies off, Some of the features that make your site experience more efficient may not
              function properly, such as showing you previously elected preferences or location settings in results.
            </p>
          </li>
          <li>
            <p>
              We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics
              cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers
              together to compile data regarding user interactions with ad impressions and other ad service functions as
              they relate to our website.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>Third-party disclosure</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information
              unless we provide users with advance notice.
            </p>
          </li>
          <li>
            <p>
              This does not include website hosting partners and other parties who assist us in operating our website,
              conducting our business, or serving our users, so long as those parties agree to keep this information
              confidential.
            </p>
          </li>
          <li>
            <p>
              We may also release information when it's release is appropriate to comply with the law, enforce our site
              policies, or protect ours or others' rights, property or safety.
            </p>
          </li>
          <li>
            <p>
              However, non-personally identifiable visitor information may be provided to other parties for marketing,
              advertising, or other uses.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>Third-party links</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              Occasionally, at our discretion, we may include or offer third-party products or services on our website.
            </p>
          </li>
          <li>
            <p>
              These third-party sites have separate and independent privacy policies. We therefore have no
              responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to
              protect the integrity of our site and welcome any feedback about these sites.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>Google</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in
              place to provide a positive experience for users.
              <a href="https://support.google.com/adwordspolicy/answer/1316548?hl=en">link</a>
            </p>
          </li>
          <li>
            <p>We use Google AdSense Advertising on our website.</p>
          </li>
          <li>
            <p>
              Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie
              enables it to serve ads to our users based on previous visits to our site and other sites on the Internet.
              Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy
              policy.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>Opting out:</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              Users can set preferences for how Google advertises to you using the Google Ad Settings page.
              Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the
              Google Analytics Opt Out Browser add on.
            </p>
          </li>
          <li>
            <p>
              You will be notified of any Privacy Policy changes on this privacy policy page (<a
                href="https://avaana.com.au/privacy-policy"
                >avaana.com.au/privacy-policy</a
              >)
            </p>
          </li>
          <li>
            <p>
              You can change your personal information by emailing
              <a href="mailto:hello@avaana.com.au">hello&#64;avaana.com.au</a>
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>How does our site handle Do Not Track signals?</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              We honour Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track
              (DNT) browser mechanism is in place.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>Does our site allow third-party behavioural tracking?</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>It's also important to note that we allow third-party behavioural tracking</p>
          </li>
        </ol>
      </li>
      <li>
        <p>COPPA (Children Online Privacy Protection Act)</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              When it comes to the collection of personal information from children under the age of 13 years old, the
              Children's Online Privacy Protection Act (COPPA) puts parents in control. We do not specifically market to
              children under the age of 13 years old.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <p>Your Email address.</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>
              We collect your email address in order to send information, respond to inquiries and/or other requests or
              questions.
            </p>
          </li>
          <li>
            <p>After "you can email at" <a href="mailto:hello@avaana.com.au">hello&#64;avaana.com.au</a>.</p>
          </li>
        </ol>
      </li>
      <li>
        <p>Contacting Us</p>
        <ol style="list-style-type: lower-roman">
          <li>
            <p>You may connect us by emailing <a href="mailto:hello@avaana.com.au">hello&#64;avaana.com.au</a>.</p>
          </li>
          <li>
            <p>
              If at any time you would like to unsubscribe from receiving future emails, you can email us at
              <a href="mailto:hello@avaana.com.au">hello&#64;avaana.com.au</a> and we will promptly remove you from all
              future correspondence. in Australia, building a community of healthy living.
            </p>
          </li>
        </ol>
      </li>
    </ol>
  </div>
</div>
